var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Error", {
    attrs: {
      title: "Error.404.Title",
      subtitle: "Error.404.Subtitle",
      buttonText: "Error.404.Button",
      buttonMethod: _vm.errorEnum.GoHome
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }